/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { caracteristiqueSchema } from "./caracteristiqueSchema.ts";
import { diffusionSchema } from "./diffusionSchema.ts";
import { localisationSchema } from "./localisationSchema.ts";
import { prixDetailSchema } from "./prixDetailSchema.ts";
import { propertyDocumentSchema } from "./propertyDocumentSchema.ts";
import { z } from "zod";

export const annonceDiffusionSchema = z.object({
      "id": z.number().int().describe("ID de l'annonce").optional(),
  "office_oid": z.string().describe("OID de l'office notarial").optional(),
  "ref_client": z.string().describe("Référence du client").optional(),
  "type_transaction": z.string().describe("Type de transaction").optional(),
  "type_bien": z.string().describe("Type de bien").optional(),
  "liste_type_bien": z.array(z.string()).describe("Liste des types de biens associés à l'annonce").optional(),
  "annonce_neuf": z.boolean().describe("Indique si le bien est neuf ou non").optional(),
  "localisation": z.lazy(() => localisationSchema).optional(),
  "prix": z.number().describe("Prix du bien BRUT").optional(),
  "detail_prix": z.lazy(() => prixDetailSchema).describe("Détail du prix d'une annonce diffusée (issu de la base annonces). Seuls les champs pertinents pour le type de transaction sont renseignés.").optional(),
  "diffusions": z.array(z.lazy(() => diffusionSchema)).optional(),
  "caracteristiques": z.lazy(() => caracteristiqueSchema).optional(),
  "photos": z.array(z.lazy(() => propertyDocumentSchema)).optional()
      })